"use strict";
'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _composeClasses = _interopRequireDefault(require("@mui/utils/composeClasses"));
var _colorManipulator = require("@mui/system/colorManipulator");
var _getValidReactChildren = _interopRequireDefault(require("@mui/utils/getValidReactChildren"));
var _capitalize = _interopRequireDefault(require("../utils/capitalize"));
var _zeroStyled = require("../zero-styled");
var _memoTheme = _interopRequireDefault(require("../utils/memoTheme"));
var _createSimplePaletteValueFilter = _interopRequireDefault(require("../utils/createSimplePaletteValueFilter"));
var _DefaultPropsProvider = require("../DefaultPropsProvider");
var _buttonGroupClasses = _interopRequireWildcard(require("./buttonGroupClasses"));
var _ButtonGroupContext = _interopRequireDefault(require("./ButtonGroupContext"));
var _ButtonGroupButtonContext = _interopRequireDefault(require("./ButtonGroupButtonContext"));
var _jsxRuntime = require("react/jsx-runtime");
var overridesResolver = function(props, styles) {
    var ownerState = props.ownerState;
    return [
        _define_property({}, "& .".concat(_buttonGroupClasses.default.grouped), styles.grouped),
        _define_property({}, "& .".concat(_buttonGroupClasses.default.grouped), styles["grouped".concat((0, _capitalize.default)(ownerState.orientation))]),
        _define_property({}, "& .".concat(_buttonGroupClasses.default.grouped), styles["grouped".concat((0, _capitalize.default)(ownerState.variant))]),
        _define_property({}, "& .".concat(_buttonGroupClasses.default.grouped), styles["grouped".concat((0, _capitalize.default)(ownerState.variant)).concat((0, _capitalize.default)(ownerState.orientation))]),
        _define_property({}, "& .".concat(_buttonGroupClasses.default.grouped), styles["grouped".concat((0, _capitalize.default)(ownerState.variant)).concat((0, _capitalize.default)(ownerState.color))]),
        _define_property({}, "& .".concat(_buttonGroupClasses.default.firstButton), styles.firstButton),
        _define_property({}, "& .".concat(_buttonGroupClasses.default.lastButton), styles.lastButton),
        _define_property({}, "& .".concat(_buttonGroupClasses.default.middleButton), styles.middleButton),
        styles.root,
        styles[ownerState.variant],
        ownerState.disableElevation === true && styles.disableElevation,
        ownerState.fullWidth && styles.fullWidth,
        ownerState.orientation === 'vertical' && styles.vertical
    ];
};
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes, color = ownerState.color, disabled = ownerState.disabled, disableElevation = ownerState.disableElevation, fullWidth = ownerState.fullWidth, orientation = ownerState.orientation, variant = ownerState.variant;
    var slots = {
        root: [
            'root',
            variant,
            orientation,
            fullWidth && 'fullWidth',
            disableElevation && 'disableElevation',
            "color".concat((0, _capitalize.default)(color))
        ],
        grouped: [
            'grouped',
            "grouped".concat((0, _capitalize.default)(orientation)),
            "grouped".concat((0, _capitalize.default)(variant)),
            "grouped".concat((0, _capitalize.default)(variant)).concat((0, _capitalize.default)(orientation)),
            "grouped".concat((0, _capitalize.default)(variant)).concat((0, _capitalize.default)(color)),
            disabled && 'disabled'
        ],
        firstButton: [
            'firstButton'
        ],
        lastButton: [
            'lastButton'
        ],
        middleButton: [
            'middleButton'
        ]
    };
    return (0, _composeClasses.default)(slots, _buttonGroupClasses.getButtonGroupUtilityClass, classes);
};
var ButtonGroupRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiButtonGroup',
    slot: 'Root',
    overridesResolver: overridesResolver
})((0, _memoTheme.default)(function(param) {
    var theme = param.theme;
    var _obj, _obj1, _obj2, _obj3;
    return _define_property({
        display: 'inline-flex',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        variants: [
            {
                props: {
                    variant: 'contained'
                },
                style: {
                    boxShadow: (theme.vars || theme).shadows[2]
                }
            },
            {
                props: {
                    disableElevation: true
                },
                style: {
                    boxShadow: 'none'
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: (_obj = {
                    flexDirection: 'column'
                }, _define_property(_obj, "& .".concat(_buttonGroupClasses.default.lastButton, ",& .").concat(_buttonGroupClasses.default.middleButton), {
                    borderTopRightRadius: 0,
                    borderTopLeftRadius: 0
                }), _define_property(_obj, "& .".concat(_buttonGroupClasses.default.firstButton, ",& .").concat(_buttonGroupClasses.default.middleButton), {
                    borderBottomRightRadius: 0,
                    borderBottomLeftRadius: 0
                }), _obj)
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: (_obj1 = {}, _define_property(_obj1, "& .".concat(_buttonGroupClasses.default.firstButton, ",& .").concat(_buttonGroupClasses.default.middleButton), {
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0
                }), _define_property(_obj1, "& .".concat(_buttonGroupClasses.default.lastButton, ",& .").concat(_buttonGroupClasses.default.middleButton), {
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0
                }), _obj1)
            },
            {
                props: {
                    variant: 'text',
                    orientation: 'horizontal'
                },
                style: _define_property({}, "& .".concat(_buttonGroupClasses.default.firstButton, ",& .").concat(_buttonGroupClasses.default.middleButton), _define_property({
                    borderRight: theme.vars ? "1px solid rgba(".concat(theme.vars.palette.common.onBackgroundChannel, " / 0.23)") : "1px solid ".concat(theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)')
                }, "&.".concat(_buttonGroupClasses.default.disabled), {
                    borderRight: "1px solid ".concat((theme.vars || theme).palette.action.disabled)
                }))
            },
            {
                props: {
                    variant: 'text',
                    orientation: 'vertical'
                },
                style: _define_property({}, "& .".concat(_buttonGroupClasses.default.firstButton, ",& .").concat(_buttonGroupClasses.default.middleButton), _define_property({
                    borderBottom: theme.vars ? "1px solid rgba(".concat(theme.vars.palette.common.onBackgroundChannel, " / 0.23)") : "1px solid ".concat(theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)')
                }, "&.".concat(_buttonGroupClasses.default.disabled), {
                    borderBottom: "1px solid ".concat((theme.vars || theme).palette.action.disabled)
                }))
            }
        ].concat(_to_consumable_array(Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()).flatMap(function(param) {
            var _param = _sliced_to_array(param, 1), color = _param[0];
            return [
                {
                    props: {
                        variant: 'text',
                        color: color
                    },
                    style: _define_property({}, "& .".concat(_buttonGroupClasses.default.firstButton, ",& .").concat(_buttonGroupClasses.default.middleButton), {
                        borderColor: theme.vars ? "rgba(".concat(theme.vars.palette[color].mainChannel, " / 0.5)") : (0, _colorManipulator.alpha)(theme.palette[color].main, 0.5)
                    })
                }
            ];
        })), [
            {
                props: {
                    variant: 'outlined',
                    orientation: 'horizontal'
                },
                style: (_obj2 = {}, _define_property(_obj2, "& .".concat(_buttonGroupClasses.default.firstButton, ",& .").concat(_buttonGroupClasses.default.middleButton), {
                    borderRightColor: 'transparent',
                    '&:hover': {
                        borderRightColor: 'currentColor'
                    }
                }), _define_property(_obj2, "& .".concat(_buttonGroupClasses.default.lastButton, ",& .").concat(_buttonGroupClasses.default.middleButton), {
                    marginLeft: -1
                }), _obj2)
            },
            {
                props: {
                    variant: 'outlined',
                    orientation: 'vertical'
                },
                style: (_obj3 = {}, _define_property(_obj3, "& .".concat(_buttonGroupClasses.default.firstButton, ",& .").concat(_buttonGroupClasses.default.middleButton), {
                    borderBottomColor: 'transparent',
                    '&:hover': {
                        borderBottomColor: 'currentColor'
                    }
                }), _define_property(_obj3, "& .".concat(_buttonGroupClasses.default.lastButton, ",& .").concat(_buttonGroupClasses.default.middleButton), {
                    marginTop: -1
                }), _obj3)
            },
            {
                props: {
                    variant: 'contained',
                    orientation: 'horizontal'
                },
                style: _define_property({}, "& .".concat(_buttonGroupClasses.default.firstButton, ",& .").concat(_buttonGroupClasses.default.middleButton), _define_property({
                    borderRight: "1px solid ".concat((theme.vars || theme).palette.grey[400])
                }, "&.".concat(_buttonGroupClasses.default.disabled), {
                    borderRight: "1px solid ".concat((theme.vars || theme).palette.action.disabled)
                }))
            },
            {
                props: {
                    variant: 'contained',
                    orientation: 'vertical'
                },
                style: _define_property({}, "& .".concat(_buttonGroupClasses.default.firstButton, ",& .").concat(_buttonGroupClasses.default.middleButton), _define_property({
                    borderBottom: "1px solid ".concat((theme.vars || theme).palette.grey[400])
                }, "&.".concat(_buttonGroupClasses.default.disabled), {
                    borderBottom: "1px solid ".concat((theme.vars || theme).palette.action.disabled)
                }))
            }
        ], _to_consumable_array(Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)([
            'dark'
        ])).map(function(param) {
            var _param = _sliced_to_array(param, 1), color = _param[0];
            return {
                props: {
                    variant: 'contained',
                    color: color
                },
                style: _define_property({}, "& .".concat(_buttonGroupClasses.default.firstButton, ",& .").concat(_buttonGroupClasses.default.middleButton), {
                    borderColor: (theme.vars || theme).palette[color].dark
                })
            };
        })))
    }, "& .".concat(_buttonGroupClasses.default.grouped), {
        minWidth: 40,
        boxShadow: 'none',
        props: {
            variant: 'contained'
        },
        style: {
            '&:hover': {
                boxShadow: 'none'
            }
        }
    });
}));
var ButtonGroup = /*#__PURE__*/ React.forwardRef(function ButtonGroup(inProps, ref) {
    var props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiButtonGroup'
    });
    var children = props.children, className = props.className, _props_color = props.color, color = _props_color === void 0 ? 'primary' : _props_color, _props_component = props.component, component = _props_component === void 0 ? 'div' : _props_component, _props_disabled = props.disabled, disabled = _props_disabled === void 0 ? false : _props_disabled, _props_disableElevation = props.disableElevation, disableElevation = _props_disableElevation === void 0 ? false : _props_disableElevation, _props_disableFocusRipple = props.disableFocusRipple, disableFocusRipple = _props_disableFocusRipple === void 0 ? false : _props_disableFocusRipple, _props_disableRipple = props.disableRipple, disableRipple = _props_disableRipple === void 0 ? false : _props_disableRipple, _props_fullWidth = props.fullWidth, fullWidth = _props_fullWidth === void 0 ? false : _props_fullWidth, _props_orientation = props.orientation, orientation = _props_orientation === void 0 ? 'horizontal' : _props_orientation, _props_size = props.size, size = _props_size === void 0 ? 'medium' : _props_size, _props_variant = props.variant, variant = _props_variant === void 0 ? 'outlined' : _props_variant, other = _object_without_properties(props, [
        "children",
        "className",
        "color",
        "component",
        "disabled",
        "disableElevation",
        "disableFocusRipple",
        "disableRipple",
        "fullWidth",
        "orientation",
        "size",
        "variant"
    ]);
    var ownerState = _object_spread_props(_object_spread({}, props), {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        disableRipple: disableRipple,
        fullWidth: fullWidth,
        orientation: orientation,
        size: size,
        variant: variant
    });
    var classes = useUtilityClasses(ownerState);
    var context = React.useMemo(function() {
        return {
            className: classes.grouped,
            color: color,
            disabled: disabled,
            disableElevation: disableElevation,
            disableFocusRipple: disableFocusRipple,
            disableRipple: disableRipple,
            fullWidth: fullWidth,
            size: size,
            variant: variant
        };
    }, [
        color,
        disabled,
        disableElevation,
        disableFocusRipple,
        disableRipple,
        fullWidth,
        size,
        variant,
        classes.grouped
    ]);
    var validChildren = (0, _getValidReactChildren.default)(children);
    var childrenCount = validChildren.length;
    var getButtonPositionClassName = function(index) {
        var isFirstButton = index === 0;
        var isLastButton = index === childrenCount - 1;
        if (isFirstButton && isLastButton) {
            return '';
        }
        if (isFirstButton) {
            return classes.firstButton;
        }
        if (isLastButton) {
            return classes.lastButton;
        }
        return classes.middleButton;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ButtonGroupRoot, _object_spread_props(_object_spread({
        as: component,
        role: "group",
        className: (0, _clsx.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ButtonGroupContext.default.Provider, {
            value: context,
            children: validChildren.map(function(child, index) {
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ButtonGroupButtonContext.default.Provider, {
                    value: getButtonPositionClassName(index),
                    children: child
                }, index);
            })
        })
    }));
});
process.env.NODE_ENV !== "production" ? ButtonGroup.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: _propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: _propTypes.default.object,
    /**
   * @ignore
   */ className: _propTypes.default.string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */ color: _propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        _propTypes.default.oneOf([
            'inherit',
            'primary',
            'secondary',
            'error',
            'info',
            'success',
            'warning'
        ]),
        _propTypes.default.string
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: _propTypes.default.elementType,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: _propTypes.default.bool,
    /**
   * If `true`, no elevation is used.
   * @default false
   */ disableElevation: _propTypes.default.bool,
    /**
   * If `true`, the button keyboard focus ripple is disabled.
   * @default false
   */ disableFocusRipple: _propTypes.default.bool,
    /**
   * If `true`, the button ripple effect is disabled.
   * @default false
   */ disableRipple: _propTypes.default.bool,
    /**
   * If `true`, the buttons will take up the full width of its container.
   * @default false
   */ fullWidth: _propTypes.default.bool,
    /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */ orientation: _propTypes.default.oneOf([
        'horizontal',
        'vertical'
    ]),
    /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */ size: _propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        _propTypes.default.oneOf([
            'small',
            'medium',
            'large'
        ]),
        _propTypes.default.string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: _propTypes.default.oneOfType([
        _propTypes.default.arrayOf(_propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object,
            _propTypes.default.bool
        ])),
        _propTypes.default.func,
        _propTypes.default.object
    ]),
    /**
   * The variant to use.
   * @default 'outlined'
   */ variant: _propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        _propTypes.default.oneOf([
            'contained',
            'outlined',
            'text'
        ]),
        _propTypes.default.string
    ])
} : void 0;
var _default = exports.default = ButtonGroup;
